export default function getContextUrl(context?: object | null) {
  return (
    context &&
    (context["type"] === "group"
      ? `/groups/${context["slug"]}`
      : context["type"] === "group_category"
        ? `/group-categories/${context["slug"]}`
        : "")
  );
}
